
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Coin_partner_orders from "./coin_partner_orders";
import Coin_seller_orders from "./coin_seller_orders";
import Coin_seller_edit from "./coin_seller_edit";
import Cash_diary from './../../nhatkyorders.jsx';
import Cash_pay_home from "./coin_seller_pay_home";
import Cash_pay_orders from "./coin_seller_pay_orders";
import Cash_pay_card from "./coin_seller_pay_card";
import Post_content from '../../community/content/Blog_posts.jsx';


const Coin_home = () => {
    const { slug_2 } = useParams();
    const [userOption, setUserOption] = useState("changeCard");
    const navigate = useNavigate();
    return (
        <>
            {slug_2 === "orders" && (
                <Coin_partner_orders />
            )}
            {slug_2 === "guide" && (
                   <Post_content mode={'hust_media'} show_adsense={'NO'} show_adskeeper={'NO'} uri={'buy_users_coins'} />
            )}
        </>
    );
}

export default Coin_home;
